<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-autocomplete
        placeholder="Cautare"
        hint="Se cauta dupa id_scara, adresa, observatii adresa si observatii"
        clearable
        persistent-hint
        append-icon="mdi-magnify"
        solo
        :loading="loading"
        single-line
        :suffix="String(total)"
        dense
        return-object
        :items="filteredItems"
        item-text="id_scara"
        item-value="_id"
        :search-input.sync="search"
        no-filter
        v-model="selectedItem">
        <template v-slot:selection="data">
          <v-avatar size="16">
            <img :src="getIcon(data.item)">
          </v-avatar>
          &nbsp;
          {{data.item.id_scara}}
        </template>
        <template v-slot:item="data">
          <v-list-tile-avatar size="22">
            <img :src="getIcon(data.item)">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="data.item.id_scara"></v-list-tile-title>
            <v-list-tile-sub-title>{{data.item.photos.length}} poze</v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
      <GmapMap
        :center="mapCenter"
        :zoom="zoom"
        :map-type-id="mapType"
        :style="{ width: options.width, height: options.height }"
        ref="map"
        @center_changed="centerChanged"
        @zoom_changed="zoomChanged"
        @maptypeid_changed="mapTypeChanged">

        <GmapMarker
          :position="currentPosition"
          :label="{ text: 'Pozitia ta', color: labelColor, fontWeight: 'bold' }"
          :icon="{ url: '/logo.svg', labelOrigin: { x: 24 / 2, y: 24 + 12 } }"
          :draggable="false"/>

        <gmap-cluster :max-zoom="16">
          <GmapMarker
            v-for="(item, index) in items"
            :key="index"
            :position="{lat: Number(item.centru_geometric.lat), lng: Number(item.centru_geometric.lng)}"
            :clickable="true"
            :icon="{
              url: getIcon(item),
              labelOrigin: { x: 36 / 2, y: 64 + 6 },
              size: markerSize,
              scaledSize: markerScale
            }"
            :label="getLabel(item)"
            :draggable="false"
            @click="navigate(item)"
            :animation="user.admin && activeEntity && activeEntity === item._id  ? 1 : null"/>
        </gmap-cluster>
      </GmapMap>
    </v-layout>
  </v-container>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
// import isEqual from 'lodash.isequal'

export default {
  name: 'entity-map',
  props: {
    entity: {
      type: String,
      required: false
    }
  },
  computed: {
    google: gmapApi,
    currentPosition () {
      return this.$store.getters.currentPosition
    },
    loading () {
      return this.$store.getters.loading
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    total () {
      return this.filteredItems.length
    },
    activeEntity () {
      return this.$route.params.entity
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/allItems']
    }
  },
  watch: {
    google: {
      immediate: true,
      handler (g) {
        if (g) {
          this.markerSize = new g.maps.Size(36, 64)
          this.markerScale = new g.maps.Size(36, 64)
        }
      }
    },
    selectedItem (v) {
      if (v) {
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({ lat: Number(v.centru_geometric.lat), lng: Number(v.centru_geometric.lng) })
          map.setZoom(19)
        })
      }
    },
    search: {
      immediate: false,
      handler: debounce(function (v) {
        this.queryItems(v)
      }, 1000)
    },
    items: {
      immediate: true,
      handler (v) {
        this.filteredItems = v
      }
    }
  },
  data: () => ({
    search: null,
    options: {
      width: '100%',
      height: '100%'
    },
    // items: [],
    filteredItems: [],
    labelColor: 'white',
    markerSize: null,
    markerScale: null,
    selectedItem: null
  }),
  methods: {
    queryItems (search) {
      this.filteredItems = search ? this.items.filter(item => this.filter(item, search, item.id_scara) || this.filter(item, search, item.adresa) || this.filter(item, search, item.observatii) || this.filter(item, search, item.observatii_adresa)) : this.items
    },
    filter (item, search, value) {
      return value ? value.toLowerCase().includes(search.toLowerCase()) : false
    },
    centerChanged: debounce(function ($event) {
      const mapCenter = { lat: $event.lat(), lng: $event.lng() }
      this.$store.commit('setMapCenter', mapCenter)
    }, 1000),
    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoom', $event)
    }, 1000),
    mapTypeChanged ($event) {
      if ($event === 'roadmap' || $event === 'terrain') this.labelColor = 'black'
      else this.labelColor = 'white'
      this.$store.commit('setMapType', $event)
    },
    getIcon (marker) {
      if (marker.addedBy) {
        if (marker.done) return '/svg/pin_done_people.svg'
        return marker.user ? '/svg/pin_edited_people.svg' : '/svg/pin_unedited_people.svg'
      } else {
        if (marker.done) return '/svg/pin_done.svg'
        return marker.user ? '/svg/pin_edited.svg' : '/svg/pin_unedited.svg'
      }
    },
    getLabel (marker) {
      return { text: String(`${marker.id_scara} (${marker.photos.length}) ${marker.adresa}`), color: this.labelColor, fontWeight: 'bold' }
    },
    navigate (marker) {
      this.$router.push({ name: 'details', params: { entity: marker._id } })
    }
  },
  mounted () {
    // this.$store.commit('setLoading', true)
    // this.$store.dispatch('entities/fetchAllEntities')
    //   .then(items => {
    //     // this.$store.commit('setLoading', false)
    //     this.items = items
    //     this.filteredItems = items
    //   })
    //   .catch(err => {
    //     // this.$store.commit('setLoading', false)
    //     console.log(err)
    //   })
  }
}
</script>

<style>

</style>
